import { useMemo } from 'react'

import { WarehouseStock } from 'app/components/warehouse/WarehouseStock'
import { WarehouseStockItemId } from 'app/common/types/id'
import { WarehouseTab } from 'app/common/types/warehouse/tabs'

import { section as movementsSection, createDishUrl } from '../WarehouseStockMovementsPage'
import { Underconstruction } from '../Underconstruction'

export const masks = []
export const section = 'stock'

export const WarehouseStockPage = ({
  siblings,
}: {
  baseUrl: string
  siblings: Array<{ section: string; baseUrl: string; otherUrls: Array<string> }>
}) => {
  const siblingsMap = useMemo(
    () => new Map(siblings.map((item) => [item.section, item])),
    [siblings],
  )

  const createDishMovementLink = (dishId: WarehouseStockItemId) =>
    createDishUrl(dishId, siblingsMap.get(movementsSection)!.otherUrls)

  return (
    <Underconstruction tab={WarehouseTab.Stock}>
      {({ title }) => (
        <WarehouseStock title={title} createDishMovementLink={createDishMovementLink} />
      )}
    </Underconstruction>
  )
}
